import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";

// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes"; 
import { SidebarProvider } from "./context/Sidebar"; 
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator"; 
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ForgotPasswordPage, LoginPage } from "./pages/auth";
import { ErrorPage } from "./pages/others";
import { AdminsListPage, CustomerAccountPage, CustomersListPage, MyAccountPage, OrganizationChartPage, SimContractTemplate, SimsListPage, SupervisorsListPage} from "./pages/main";

import { ToastContainer } from 'react-toastify';
import AgentsListPage from "./pages/main/AgentsListPage";
import UserAccountPage from "./pages/main/UserAccountPage";
import RolesListPage from "./pages/main/RolesListPage";
import RolePage from "./pages/main/RolePage";
import SettingsListPage from "./pages/main/SettingsListPage";
import CustomerCreatePage from "./pages/main/CustomerCreatePage";
import CountriesListPage from "./pages/main/CountriesListPage";
import CitiesListPage from "./pages/main/CitiesListPage";
import StatesListPage from "./pages/main/StatesListPage";
import CountryCreatePage from "./pages/main/CountryCreatePage";
import CityCreatePage from "./pages/main/CityCreatePage";
import SimDetailsPage from "./pages/main/SimDetailsPage";
import SetPasswordPage from "./pages/auth/SetPasswordPage";
import TeamsListPage from "./pages/main/TeamsListPage";
import TeamCreatePage from "./pages/main/TeamCreatePage";
import UserTypesPage from "./pages/main/UserTypesPage";
import UserTypeDetailsPage from "./pages/main/UserTypeDetailsPage";
import UsersManagementPage from "./pages/main/UsersManagementPage";
import NotFoundPage from "./pages/NotFoundPage";
import DashboardPage from "./pages/main/DashboardPage";

// Import the permission wrapper
import { WithPermissionCheck } from "./utils/WithPermissionCheck";

const router = createBrowserRouter([
    // Public routes (no permission check needed)
    { path: "/login", element: <LoginPage /> },
    { path: "/", element: <LoginPage /> },
    { path: "/set-password", element: <SetPasswordPage /> },
    { path: "/forgot-password", element: <ForgotPasswordPage /> },
    { path: "/error", element: <ErrorPage /> },
    { path: "/my-account", element: <MyAccountPage /> },

    // Protected routes (require permissions)
    { path: "/admin-list", element: WithPermissionCheck(AdminsListPage) },
    { path: "/supervisor-list", element: WithPermissionCheck(SupervisorsListPage) },
    { path: "/agent-list", element: WithPermissionCheck(AgentsListPage) },
    
    { path: "/customer-list", element: WithPermissionCheck(CustomersListPage) },
    { path: "/customer-account/:id?", element: WithPermissionCheck(CustomerAccountPage) },
    { path: "/customer-create", element: WithPermissionCheck(CustomerCreatePage) },
    
    { path: "/sim-contract-template", element: WithPermissionCheck(SimContractTemplate) },
    { path: "/sim-list", element: WithPermissionCheck(SimsListPage) },
    { path: "/sim/:id", element: WithPermissionCheck(SimDetailsPage) },
    
    { path: "/role-list", element: WithPermissionCheck(RolesListPage) },
    { path: "/role/:id?", element: WithPermissionCheck(RolePage) },
    
    { path: "/user-account/:id?", element: WithPermissionCheck(UserAccountPage) },
    { path: "/settings", element: WithPermissionCheck(SettingsListPage) },

    { path: "/countries", element: WithPermissionCheck(CountriesListPage) },
    { path: "/countries/:countryId/cities", element: WithPermissionCheck(CitiesListPage) },
    { path: "/cities/:countryId/states", element: WithPermissionCheck(StatesListPage) },
    { path: "/country-create", element: WithPermissionCheck(CountryCreatePage) },
    { path: "/city-create/:countryId", element: WithPermissionCheck(CityCreatePage) },
    
    { path: "/team-list", element: WithPermissionCheck(TeamsListPage) },
    { path: "/team/:id", element: WithPermissionCheck(TeamCreatePage) },
    { path: "/team-create", element: WithPermissionCheck(TeamCreatePage) },
    
    { path: "/user-types", element: WithPermissionCheck(UserTypesPage) },
    { path: "/user-types/:id", element: WithPermissionCheck(UserTypeDetailsPage) },
    { path: "/users-management", element: WithPermissionCheck(UsersManagementPage) },
    
    { path: "/organization-chart", element: WithPermissionCheck(OrganizationChartPage) },
    { path: "/dashboard", element: <DashboardPage /> },
    
    { path: "*", element: <NotFoundPage /> }
]);

createRoot(document.getElementById("root")).render(
    <ThemeProvider>
        <LoaderProvider>
            <TranslatorProvider>
                <SidebarProvider>
                    <ToastContainer />
                    <RouterProvider router={router} />
                </SidebarProvider>
            </TranslatorProvider>
        </LoaderProvider>
    </ThemeProvider>
);
